// extracted by mini-css-extract-plugin
export default {"functionsLoginTabs":"LoginTabs_functionsLoginTabs__luIzX","functionLoginTabsActive":"LoginTabs_functionLoginTabsActive__23t1O"};